/**
 * Auto-initialization module
 * Import this to automatically connect to the extension with default settings
 *
 * @example
 * ```typescript
 * // In your main entry file (e.g., index.ts or main.ts)
 * import '@graphql-stream-viewer/helper/auto';
 * ```
 */

import { connectDevTools } from './index';

// Automatically connect when this module is imported
if (typeof window !== 'undefined') {
	// Wait for DOM to be ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			connectDevTools({
				debug: process.env.NODE_ENV === 'development',
			});
		});
	} else {
		// DOM already loaded
		connectDevTools({
			debug: process.env.NODE_ENV === 'development',
		});
	}
}

// Note: No exports - this is a side-effect only module
